module.exports = __webpack_public_path__ + "img/support-mitte.c9cb76e3.jpg";